import React from "react";
import { Form } from "react-bootstrap";
import Input from "../../../components/Input/Input";
import Button from "../../../components/Button/Button";
import Switch from "../../../components/Switch/Switch";

const ParentAppFeatureForm = ({
  submitHandler,
  changeHandler,
  formData,
  onDefaultToggle,
  isEditMode,
}) => {
  const { key, name, description, is_enabled_by_default } = formData;

  return (
    <Form onSubmit={submitHandler}>
      <div className="row">
        <div className="col-md-6">
          <Input
            label="Feature Key"
            type="text"
            name="key"
            value={key}
            placeholder="e.g. homework"
            onChangeHandler={changeHandler}
            required={true}
            disabled={isEditMode}
          />
        </div>

        <div className="col-md-6">
          <Input
            label="Feature Name"
            type="text"
            name="name"
            value={name}
            placeholder="e.g. Homework"
            onChangeHandler={changeHandler}
            required={true}
          />
        </div>

        <div className="col-md-12">
          <Input
            label="Description"
            type="text"
            name="description"
            value={description}
            placeholder="Brief description of this feature"
            onChangeHandler={changeHandler}
          />
        </div>

        <div className="col-md-12 mt-2">
          <Form.Label className="mb-1 mt-1 text-capitalize fw-semibold">
            Enabled by Default
          </Form.Label>
          <div className="paf-default-switch-wrap">
            <Switch
              id="paf-default-switch"
              name="is_enabled_by_default"
              label={
                is_enabled_by_default
                  ? "Yes – enabled for all orgs by default"
                  : "No – disabled by default"
              }
              checked={!!is_enabled_by_default}
              value="1"
              onChange={onDefaultToggle}
            />
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <Button variant="primary" type="submit">
          Submit
        </Button>
      </div>
    </Form>
  );
};

export default ParentAppFeatureForm;
